function findExistingPurchasePlan (plans, unlockCatalog) {
  if (!unlockCatalog?.hasExistingPurchase || !Array.isArray(plans) || plans.length === 0) return null

  // Older API responses only checked the first catalog product. Keep that
  // fallback narrow so a returning customer is never routed through a plan
  // from a different product by price, interval, label, or recommendation.
  const productId = unlockCatalog.existingPurchaseProductId || plans[0].productId
  return plans.find((plan) => plan.productId === productId) || null
}

// Flows preview only (`previewState=owned`): the owned panel is forced for a
// catalog that may not report an owner. Use the real ownership rules when the
// catalog does; otherwise any plan is only a display target — nothing is ever
// submitted from a preview.
function findPreviewOwnedPlan (plans, unlockCatalog) {
  if (!Array.isArray(plans) || plans.length === 0) return null
  return findExistingPurchasePlan(plans, unlockCatalog) || plans[0]
}

module.exports = { findExistingPurchasePlan, findPreviewOwnedPlan }
